export class EventSelect{
    public Id: number; 
    public Descricao : string;
    public IsOnline: boolean;
    public NumeroInscritos: number;
    public NumeroVisualizacoes: number;
}

export class Event {
    public Id: number; 
    public Descricao : string;
    public DataInicial : Date;
    public DataFinal : Date;
    public LocalEventoId : Number;
    public DataAtualizacao :Date;
    public IsDeleted : boolean;
    public DataCadastro : Date;
    public DataLimiteManualEletronico : Date;
    public DataInicialInscricoesernet : Date;
    public DataFinalInscricoesernet : Date;
    public NumeroVagas : number;
    public InscricaoNoLocal : boolean;
    public EntregaCrachaEmCasa : boolean;
    public ValorSegundaViaCracha : number;
    public DataLimiteEntregaCracha : Date;
    public PontuacaoCna : number;
    public PathImagemCertificado : string;
    public IsHidden : boolean;
    public NumInscritos : number;
    public HasAcompanhantes : boolean;
    public NumAcompanhantesCadastrados : number;
    public ValorAcompanhante : number;
    public NumeroAcompanhantes : number;
    public MultiplosEnderecos : boolean;
}


// WEBPACK FOOTER //
// ./src/models/event.model.ts